<template>
  <section class="editorial-cover" :id="`uuid-${model.uuid}`">
    <div class="editorial-cover__block">
      <div class="editorial-cover__image">
        <picture>
          <source
            media="(min-width:0) and (max-width:1024px)"
            :srcset="model.imageMobile | mgnlMedia('url')"
            v-if="model.imageMobile"
          />
          <source media="(min-width:1025px)" :srcset="model.image | mgnlMedia('url')"/>
          <pg-image :lazy-src="model.image | mgnlMedia('url')" :alt="model.altImage"></pg-image>
        </picture>
      </div>
    </div>
    <div class="editorial-cover__block editorial-cover-wrap">
      <div :class="layoutStyleBg"></div>
      
      <div :class="layoutStyle">
        <div class="editorial-cover__content">
          <component :is="headingTag" :class="headingClass" v-if="model.title">{{ model.title }}</component>
          <component
            :is="subheadingTag"
            class="text--heading-s"
            v-if="model.subtitle"
          >{{ model.subtitle }}
          </component>
          <div class="editorial__text text--body" v-html="model.text"></div>
          <p v-if="model.ctaLinks" class="editorial__cta" :class="(model.listStyle === 'contained' || model.listStyle === 'outline') ? 'margin-top__btn-m' : 'padding-left-right-0'">
            <span v-for="ctaObj in model.ctaLinks" :key="ctaObj.uuid">
              <advanced-button-wrapper :sectionStyle="model.listStyle === 'outline' ? 'secondary' : ''" :cta-obj="ctaObj"
                                       :styleType="model.listStyle || 'text'" :size="'medium'"
                                       :color="(model.listStyle === 'contained' || model.listStyle === 'outline') ? 'primary' : ''" :analyticsData="analyticsData(ctaObj)"/>
            </span>
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {mgnlComponentMixin} from "@wl-vue-mixins/mixins.js";
import PgButton from "../Button/Button.vue";
import PgImage from "../Image/Image.vue";
import AdvancedButtonWrapper from "../Advanced-Button-Wrapper/Advanced-Button-Wrapper";

export default {
  mixins: [mgnlComponentMixin], // !!! all the mgnl components must be configured with mgnlComponentMixin !!!
  name: "EditorialCoverImage",
  components: {
    AdvancedButtonWrapper,
    PgButton,
    PgImage
  },
  computed: {
    layoutStyle() {
      return this.model.layout === "align-right"
        ? "editorial-cover__container editorial-cover__container--right"
        : "editorial-cover__container editorial-cover__container--left";
    },
    layoutStyleBg() {
      return this.model.layout === "align-right"
        ? "editorial-cover__content-bg editorial-cover__content-bg--right"
        : "editorial-cover__content-bg";
    },
    headingClass() {
      return this.model.headingStyle === "large"
        ? "editorial__title text--heading-l"
        : "editorial__title text--heading-m";
    },
    headingTag() {
      return this.model.headingStyle === "large" ? "h2" : "h3";
    },
    subheadingTag() {
      return this.model.headingStyle === "large" ? "h3" : "h4";
    }
  },
  methods: {
    setLinkType(linkToDocument, linkToPage) {
      if (linkToDocument) {
        return this.$options.filters.mgnlMedia(linkToDocument, "url");
      } else {
        return this.$options.filters.mgnlLink(linkToPage, "url");
      }
    },
    analyticsData(el) {
      return {
        evCategory: 'call_to_action',
        evAction: el.document?.url || el.link?.url || el.trackingLabel,
        evLabel: `${el.campaignId || 'No Campaign'} | ${this.common.actpageFullUrl}`
      }
    }
  }
};
</script>